import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './CarouselCard.style';

import AskVeloButton from '../AskVeloButton/AskVeloButton';

const subtitleValues = {
  bold: (chunks) => (
    <Text component="span" size="sm" weight="medium" color="secondary">
      {chunks}
    </Text>
  ),
};
function CarouselCard({ imageSrc, imageAltId, titleId, subtitleId, to, href, buttonTextId, elementName, target }) {
  const { formatMessage: fm } = useIntl();

  return (
    <Styled.Root>
      <Styled.Image alt={fm({ id: imageAltId })} src={imageSrc} />
      <Styled.CardContent>
        <ContentHeader
          title={
            <Text size="md" weight="medium" color="primary" sx={{ maxWidth: '72ch' }}>
              <FormattedMessage id={titleId} />
            </Text>
          }
          subtitle={
            <Text size="sm" weight="regular" color="secondary" sx={{ maxWidth: '72ch' }}>
              <FormattedMessage id={subtitleId} values={subtitleValues} />
            </Text>
          }
        >
          <Box width="fit-content">
            <AskVeloButton
              clickstreamProps={{
                elementName,
              }}
              messageId={buttonTextId}
              to={to}
              href={href}
              target={target}
            />
          </Box>
        </ContentHeader>
      </Styled.CardContent>
    </Styled.Root>
  );
}

CarouselCard.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAltId: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  subtitleId: PropTypes.string.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  buttonTextId: PropTypes.string,
  elementName: PropTypes.string.isRequired,
  target: PropTypes.string,
};

export default CarouselCard;
